module.exports = __webpack_public_path__ + "media/public/img/profile-logo-d1a8e230fb1b8f12adc913e4f4d7365c.png";